import { capitalizeFirstLetter } from 'utils/string'

import { tenantValue } from './tenant.runtime'

export const COMPANY_ID = tenantValue('id', process.env.REACT_APP_COMPANY_ID)
export const COMPANY_NAME = tenantValue('name', process.env.REACT_APP_COMPANY_NAME)
export const COMPANY_NAME_C = `${COMPANY_NAME}`.toUpperCase()
export const COMPANY_NAME_FC = capitalizeFirstLetter(COMPANY_NAME)
export const REACT_APP_DEV = process.env.REACT_APP_DEV

export const COMPANY_TITLE = tenantValue('title', process.env.REACT_APP_COMPANY_TITLE)

export const COMPANY_DNS = tenantValue('dns', process.env.REACT_APP_COMPANY_DNS)
export const COMPANY_WEBSITE_URL = COMPANY_DNS

export const COMPANY_LOGO = tenantValue('logoUrl', process.env.REACT_APP_COMPANY_LOGO)

export const COMPANY_ICON = process.env.REACT_APP_SITE_ICON

export const COMPANY_LANDING_URL = (process.env.REACT_APP_API_URL || '')
  .replace('api.commercial.', '')
  .replace('-', '.')

export const IS_MAIN_COMPANY = COMPANY_ID == 'nextres'
export const IS_NEXYS_COMPANY = COMPANY_ID == 'nexys'
export const IS_FINRESI_SYNC = COMPANY_ID == 'nextres'
export const IS_STAGING = REACT_APP_DEV == 'true'
export const IS_PRODUCTION = !IS_STAGING || !IS_MAIN_COMPANY
export const IS_DEV_ACCOUNT = (email: string) => ['bigluckypal@gmail.com', 'byoung@nexys.com'].includes(email)

export const DISABLE_CLOSING_COST_ESTIMATE = IS_PRODUCTION

export const TRACKING_UUID_KEY = 'nexys_tracking_uuid'

export const PROJECT_NAME = (() => {
  let projectName = COMPANY_ID
  if (IS_MAIN_COMPANY && IS_STAGING) projectName = `${COMPANY_ID}staging`
  return projectName
})()

export const IS_COMPANY_CC = COMPANY_ID == 'cc'

export const IS_COMPANY_KIRK = ['nextres', 'cf'].includes(COMPANY_ID as string)

export const IS_MAIN_COMPANY_STAGING = IS_MAIN_COMPANY && IS_STAGING
